<template>
  <div class="mb-5 sm:rounded-2xl rounded-lg sm:p-5 p-2.5 bg-primary-blue/2">
    <h3 class="mb-2.5 text-center text-primary-blue sm:text-base text-sm">
      {{ $t("contact.login_required") }}
    </h3>
    <div class="flex items-center justify-center space-x-5 w-full">
      <NuxtLink :to="$localePath('/auth/register')">
        <BaseButton
          variant="outline"
          class="rounded-lg w-full"
          :label="$t('contact.register')"
        />
      </NuxtLink>
      <NuxtLink :to="$localePath('/auth/login')">
        <BaseButton class="w-full" :label="$t('contact.login')" />
      </NuxtLink>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
